import "./App.css";
import { Navigate, Route, Routes } from "react-router-dom";
import { AuthProvider, useAuth } from "./components/auth/AuthProvider";
import { Login } from "./components/auth/Login";
import { SignUp } from "./components/auth/SignUp";
import Nav from "./components/nav/Nav";
import { ProtectedRoute } from "./components/util/ProtectedRoute";
import { Home } from "./components/dashboard/Home";
import { FoodCatalog } from "./components/food/FoodCatalog";
import { CartPage } from "./components/cart/CartPage";
import { OrdersPage } from "./components/order/OrdersPage";
import { CategoriesPage } from "./components/admin/CategoriesPage";
import { FoodsAdminPage } from "./components/admin/FoodsAdminPage";
import { OrdersAdminPage } from "./components/admin/OrdersAdminPage";
import { PaymentsPage } from "./components/admin/PaymentsPage";
import { UsersPage } from "./components/admin/UsersPage";

const RootRedirect = () => {
  const { isAuthenticated } = useAuth();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return (
    <Navigate
      to="/home"
      replace
    />
  );
};

function AppShell() {
  return (
    <div className="min-h-screen bg-stone-100 text-slate-900">
      <Nav />
      <main className="mx-auto max-w-7xl px-4 py-6 sm:px-6 lg:px-8">
        <Routes>
          <Route path="/" element={<RootRedirect />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<SignUp />} />
          <Route
            path="/home"
            element={
              <ProtectedRoute>
                <Home />
              </ProtectedRoute>
            }
          />
          <Route
            path="/foods"
            element={
              <ProtectedRoute roles={["CUSTOMER"]}>
                <FoodCatalog />
              </ProtectedRoute>
            }
          />
          <Route
            path="/cart"
            element={
              <ProtectedRoute roles={["CUSTOMER"]}>
                <CartPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/orders"
            element={
              <ProtectedRoute roles={["CUSTOMER"]}>
                <OrdersPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/categories"
            element={
              <ProtectedRoute roles={["ADMIN"]}>
                <CategoriesPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/foods"
            element={
              <ProtectedRoute roles={["ADMIN"]}>
                <FoodsAdminPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/orders"
            element={
              <ProtectedRoute roles={["ADMIN"]}>
                <OrdersAdminPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/payments"
            element={
              <ProtectedRoute roles={["ADMIN"]}>
                <PaymentsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/users"
            element={
              <ProtectedRoute roles={["ADMIN"]}>
                <UsersPage />
              </ProtectedRoute>
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <AppShell />
    </AuthProvider>
  );
}

export default App;
